/* unplugin-vue-components disabled */import script from "./DramaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaPage.vue?vue&type=script&setup=true&lang=js"

import "./DramaPage.vue?vue&type=style&index=0&id=5ca60249&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca60249"]])

export default __exports__